import axios from 'axios';
import localStorageService from './local-storage-service'; // must have getToken() and clearToken()
import ToastService from './toaster-service';
import { messageEnum } from '../dictionary/global-enums';
import { ApiRoutes } from '../dictionary/api-url';
const baseURL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Request Interceptor – Attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorageService.getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor – Redirect on 401
axiosInstance.interceptors.response.use(
  (response) => {
    if(response.data.success === false && (response.data.message.toLowerCase() === messageEnum.authenticationFailed.toLowerCase() || response.data.message.toLowerCase() === messageEnum.authenticationRequired.toLowerCase())){
      ToastService.error(messageEnum.sessionExpired);
      setTimeout(() => {
        localStorageService.clearToken();
        window.location.href = '/';
      }, 500);
      return response;
    }
    return response;
  },
  (error) => {
    if ((error.config.url !== ApiRoutes.LOGIN_ADMIN && error.config.url !== ApiRoutes.LOGIN_COACH_TEAM_MEMBER && error.config.url !== ApiRoutes.LOGIN_BUSINESS )  && error.response?.status === 401) {
      localStorageService.clearToken();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// ✅ Unified Axios Service with all REST methods
const axiosService = {
  get: (url, config = {}) => axiosInstance.get(url, config),

  post: (url, data = {}, config = {}) => axiosInstance.post(url, data, config),

  put: (url, data = {}, config = {}) => axiosInstance.put(url, data, config),

  patch: (url, data = {}, config = {}) => axiosInstance.patch(url, data, config),

  delete: (url, config = {}) => axiosInstance.delete(url, config),
};

export default axiosService;
